import { type ReactNode } from 'react';
import { Button } from '@/components/ui/button';

type Props = {
  label: string;
  isPending: boolean;
  onConfirm: () => void;
  onCancel: () => void;
};

export function DistributeModalContent({
  label,
  isPending,
  onConfirm,
  onCancel,
}: Props): ReactNode {
  return (
    <>
      <p className="text-sm text-text-secondary">
        Se redistribuirán los creators sin contactar entre todos los{' '}
        {label.toLowerCase()} activos.
      </p>
      <div className="mt-lg flex justify-end gap-sm">
        <Button variant="ghost" size="sm" onClick={onCancel}>
          Cancelar
        </Button>
        <Button size="sm" onClick={onConfirm} disabled={isPending}>
          Distribuir
        </Button>
      </div>
    </>
  );
}
